import React from 'react';
import { injectIntl } from 'react-intl';
import { TextField } from '@mui/material';

interface ProfileControlProps {
  intl: any;
  profileName: string;
  onChangeProfileName: (name: string) => void;
}

const ProfileControl: React.FC<ProfileControlProps> = ({ intl, profileName, onChangeProfileName }) => (
  <div className="studio-profile-control">
    <TextField
      {...({
        fullWidth: true,
        size: 'small',
        variant: 'outlined',
        label: intl.formatMessage({ id: 'hot-topic-studio-profile-name' }),
        value: profileName,
        inputProps: { maxLength: 48 },
        InputLabelProps: { shrink: true },
        onChange: (event: React.ChangeEvent<HTMLInputElement>) => onChangeProfileName(event.target.value)
      } as any)}
    />
  </div>
);

export default injectIntl(ProfileControl);
